import { ReactComponent as Arrow } from "../stories/assets/icon-arrow-left-small-mono.svg";

const Arr = () => {
    return (
            <Arrow  /> //이렇게 
  );
  };
  
  export default Arr;